import { useFlagStore } from '@/stores/flag';
import pinia from '@/stores/pinia';

/**
 * Check if the Team Activity feature flag is enabled.
 */
export function isTeamActivityEnabled() {
  try {
    const flagStore = useFlagStore(pinia);
    return flagStore.ready && flagStore.flags.communityTeamActivity;
  } catch {
    return false;
  }
}
